// Bootstraps all widgets that form groupe-bt
import { widgetRegistration as CoreRegistration } from '@matix/gatsby-theme-core/src/components/widget-registration';
import { registerEvents } from '@matix/gatsby-theme-events';
import { registerShopify } from '@matix/gatsby-theme-shopify';
registerShopify(CoreRegistration);
registerEvents(CoreRegistration);
export const widgetRegistration = CoreRegistration;
